export const ru = {
    'adres-nazvanie-organizacii-i':
        'Адрес, название организации и имя контактного лица должны быть написаны с заглавной буквы.',
    'adres-sayta-na-kotorom':
        'Адрес сайта, на котором осуществляется раскрытие информации.',
    'adres-sayta-na-kotorom-157':
        'адрес сайта, на котором осуществляется раскрытие информации.',
    'alkogolnuyu-produkciyu': 'алкогольную продукцию',
    'alkogolnuyu-produkciyu-140': 'алкогольную продукцию;',
    'azartnye-igry': 'азартные игры',
    'azartnye-igry-sportivnye-prognozy':
        'азартные игры, спортивные прогнозы, букмекерские конторы',
    'azartnye-igry-sportivnye-prognozy-139':
        'азартные игры, спортивные прогнозы, букмекерские конторы;',
    'bankovskie-strahovye-uslugi': 'Банковские, страховые услуги',
    'bazy-dannyh-i-programmnoe': 'Базы данных и программное обеспечение.',
    'bazy-dannyh-i-programmnoe-148': 'базы данных и программное обеспечение;',
    'bystrye-ssylki-ne-nbsp':
        'Быстрые ссылки не дублируют основную ссылку объявления.',
    'bystrye-ssylki-vedut-na':
        'Быстрые ссылки ведут на страницы с товарами (работами/услугами), реклама которых может быть размещена только после того, как вы предоставите необходимый комплект подтверждающих документов (лицензия, сертификат, декларация, регистрационное удостоверение и т.п.).',
    'c-pravilami-razmeshcheniya-reklamy':
        'C правилами размещения рекламы на Яндексе вы можете ознакомиться {link}. ',
    'c-pravilami-razmeshcheniya-reklamy-param-link': 'здесь',
    'cennye-bumagi': 'Ценные бумаги',
    'deystviya-pobuzhdayushchie-k-nbsp':
        'действия, побуждающие к нарушению закона',
    'distancionnuyu-prodazhu-tovarov-zapreshchyonnyh':
        'дистанционную продажу товаров, запрещённых к реализации дистанционным способом (ювелирные изделия, лекарственные средства и др.)',
    'dlya-proverki-korrektnosti-zapolneniya':
        'Для проверки корректности заполнения вы можете {send}.',
    'dlya-proverki-korrektnosti-zapolneniya-param-send':
        'прислать электронную копию гарантийного письма',
    'dopustimo-ispolzovat-tolko-te':
        'Допустимо использовать только те изображения, которые имеют непосредственное отношение к заголовку, тексту баннера и содержанию страницы сайта.',
    'dopustimo-ispolzovat-tolko-te-115':
        'Допустимо использовать только те изображения, которые имеют непосредственное отношение к заголовку, тексту объявления и содержанию страницы сайта.',
    download: 'Скачать',
    'drugie-link-tovary-i':
        'другие {link}, реклама которых запрещена или ограничена в интернете',
    'drugie-link-tovary-i-param-link': 'товары и услуги',
    'drugie-other-tovary-i':
        'другие {other}, реклама которых запрещена или ограничена законодательством Республики Казахстан',
    'drugie-other-tovary-i-param-other': 'товары и услуги',
    'drugie-rules-tovary-i':
        'другие {rules}, реклама которых запрещена или ограничена в интернете.',
    'drugie-rules-tovary-i-param-rules': 'товары и услуги',
    'elementy-dizayna-stranic-yandeksa':
        'Элементы дизайна страниц Яндекса (например, изображение поисковой строки, процесса ввода поискового запроса, кнопок, имитирующих интерфейс Яндекса).',
    'elementy-interfeysa-ili-dizayna':
        'Элементы интерфейса или дизайна, которые могут ввести пользователя в заблуждение и не приводят к желаемому результату (например, кнопка купить, которая ведёт на главную страницу сайта, а не на страницу заказа конкретного товара).',
    'elementy-interfeysa-ili-dizayna-170':
        'элементы интерфейса или дизайна, которые могут ввести пользователя в заблуждение и не приводят к желаемому результату;',
    'elementy-interfeysa-kotorye-mogut':
        'элементы интерфейса, которые могут ввести пользователя в заблуждение;',
    'esli-dlya-vashih-tovarov':
        'Если для ваших товаров / услуг дополнительно требуется гарантийное письмо от плательщика, ниже вы можете скачать подготовленный шаблон, а затем заполнить недостающие поля в соответствии с {rules}',
    'esli-dlya-vashih-tovarov-param-rules':
        'правилами оформления гарантийного письма',
    'esli-reklamiruetsya-novostnoy-resurs':
        'Если рекламируется новостной ресурс, баннер должен вести на страницу именно с той статьёй, которая заявлена в рекламе.',
    'esli-reklamiruetsya-novostnoy-resurs-107':
        'Если рекламируется новостной ресурс, объявление должно вести на страницу именно с той статьёй, которая заявлена в рекламе.',
    'esli-u-vas-est':
        'Если у вас есть подобные заключения, добавьте ссылку на них на странице перехода и {link}.',
    'esli-u-vas-est-param-link': 'сообщите об этом нам',
    'esli-u-vas-net':
        'Если у вас нет таких заключений, замените слова в превосходной степени — например, «лучший», «новейший» — на фразы «один из лучших», «современный» и т.п.',
    'esli-u-vas-net-132':
        'Если у вас нет таких заключений, вы можете заменить слова в превосходной степени — например, «лучший», «новейший» — на фразы «один из лучших», «современный» и т.п.',
    'esli-v-nbsp-obyavlenii':
        'Если в объявлении используется и виртуальная визитка, и ссылка на сайт, то информация о скидке, акции или о конкретном товаре (услуге) в них должна совпадать.',
    'eto-kasaetsya-ne-nbsp':
        'Это касается не только непосредственно предвыборной агитации, но и рекламы сайтов депутатов, политических деятелей, их приёмных.',
    'etot-spisok-ne-nbsp':
        'Этот список не является полным. {rules} о требованиях к изображениям.',
    'etot-spisok-ne-nbsp-param-rules': 'Подробнее',
    'filmy-igry-muzyka': 'Фильмы, игры, музыка.',
    'filmy-igry-muzyka-149': 'фильмы, игры, музыка;',
    'general-topic': 'Общее',
    'graficheskoe-obyavlenie-ne-dolzhno':
        'Графическое объявление не должно содержать:',
    'graficheskoe-obyavlenie-o-bad':
        'Графическое объявление о БАД должно содержать предупреждение о том, что товар не является лекарством. Информация должна занимать не менее 10% площади графического объявления.',
    'graficheskoe-obyavlenie-o-distancionnoy':
        'Графическое объявление о дистанционной продаже товаров должно содержать наименование юридического лица/ФИО индивидуального предпринимателя, его адрес и ОГРН.',
    'graficheskoe-obyavlenie-o-lekarstvennyh':
        'Графическое объявление о лекарственных средствах, медицинской технике, медицинских услугах и методах лечения должно содержать предупреждение о наличии противопоказаний, необходимости ознакомления с инструкцией по применению или получения консультации специалиста. Предупреждение должно занимать не менее 5% площади графического объявления.',
    'graficheskoe-obyavlenie-o-produktah':
        'Графическое объявление о продуктах, включённых в рацион ребёнка в течение его первого года жизни, или заменителях женского молока должно содержать возрастное ограничение применения и предупреждение о необходимости консультации специалиста.',
    'graficheskoe-obyavlenie-o-provedenii':
        'Графическое объявление о проведении стимулирующего мероприятия (например, лотереи или конкурса) должно содержать:',
    'graficheskoe-obyavlenie-o-zhilishchno':
        'Графическое объявление о жилищно-накопительном кооперативе (ЖНК) должно содержать:',
    'gramotnyy-kachestvennyy-i-komfortnyy':
        'грамотный, качественный и комфортный для восприятия, без помех, резких или слишком громких звуков;',
    'html5-babyfood-recommendation':
        'Специальные требования к рекламе детского питания',
    'html5-bad-quality-recommendation':
        'Качество изображения должно быть высоким, не допускаются яркие цвета, мелькающие кадры',
    'html5-bad-text-recommendation':
        'Текст должен свободно восприниматься пользователем',
    'html5-finance-recommendation':
        'Специальные требования к рекламе финансовых услуг',
    'html5-funds-recommendation':
        'Специальные требования к рекламе управления акциями, фондами, накоплениями',
    'html5-house-cooperative-recommendation':
        'Специальные требования к рекламе жилищного кооператива',
    'html5-hrefs-errors-recommendation-list-item1':
        'Открытие рекламируемого сайта должно происходить в новом окне, только по клику пользователя левой кнопки мыши на баннер.',
    'html5-hrefs-errors-recommendation-list-item2':
        'Переход на страницу, указанную в поле «Ссылка на сайт» на странице создания или редактирования группы объявлений, должен генерироваться в баннере вызовом метода yandexHTML5BannerApi.getClickNum(1).',
    'html5-hrefs-errors-recommendation-list-title':
        'В соответствии с требованиями',
    'html5-illness-recommendation':
        'Не допускается натуралистическое изображение болезни.',
    'html5-interface-element-recommendation':
        'В баннере не допускаются нефункциональные элементы интерфейса и элементы дизайна страниц Яндекса.',
    'html5-lottery-recommendation':
        'Специальные требования к рекламе стимулирующих мероприятий',
    'html5-medicine-recommendation':
        'Специальные требования к рекламе лекарственных средств, медицинских услуг, в том числе методов лечения, медицинской техники',
    'html5-nasty-recommendation':
        'Использовано изображение, которое может быть воспринято неоднозначно, шокировать или вызывать негативные эмоции',
    'html5-no-border-recommendation':
        'Рекламный баннер должен иметь видимые границы',
    'html5-no-source-recommendation':
        'Нет четкого представления, кто является источником информации',
    'html5-requirements': 'Технические требования к баннеру HTML5 в Директе',
    'html5-russian-law-recommendation':
        'Реклама не соответствует действующему законодательству. Подробнее о причине отклонения вы можете прочитать {link}.',
    'html5-securities-recommendation':
        'Специальные требования к рекламе ценных бумаг',
    'html5-share-building-recommendation':
        'Специальные требования к рекламе долевого строительства',
    'html5-smi-recommendation':
        'Специальные требования к рекламе информационной продукции',
    'html5-spam-recommendation':
        'Рекламные материалы не могут быть размещены в Директе. Подробнее о причине отклонения вы можете прочитать {link}.',
    'informaciya-o-predostavitele-uslug':
        'Информация о предоставителе услуг должна быть визуально выделена (например, размером, шрифтом или подчёркиванием) и свободно восприниматься потребителем одновременно с рекламой без совершения дополнительных действий.',
    'informaciyu-o-poryadke-pokrytiya':
        'Информацию о порядке покрытия членами ЖНК понесённых ими убытков',
    'informaciyu-o-poryadke-pokrytiya-155':
        'информацию о порядке покрытия членами ЖНК понесённых им убытков;',
    'intellectual-property-topic': 'Интеллектуальная собственность',
    'intimnye-foto-foto-intimnyh': 'интимные фото/фото интимных товаров;',
    'isklyucheniem-yavlyayutsya-ssylki-na':
        'Исключением являются ссылки на страницу объекта рекламирования в социальных сетях.',
    'isklyuchite-iz-nbsp-teksta':
        'Исключите из текста креатива слова в превосходной или сравнительной степени',
    'ispolzovat-mnogokratnye-povtory-odnih':
        'использовать многократные повторы одних и тех же слов или фраз.',
    'ispolzovat-nekorrektnye-sokrashcheniya':
        'использовать некорректные сокращения;',
    'ispolzovat-r-nbsp-a': 'использовать р а з р я д к у;',
    'ispolzovat-r-nbsp-a-137':
        'использовать р а з р я д к у в тексте объявления;',
    'ispolzovat-zhargon-i-nbsp':
        'использовать жаргон и просторечные выражения;',
    'istochnik-gde-mozhno-oznakomitsya':
        'Источник, где можно ознакомиться с информацией об организаторе мероприятия, правилах проведения, количестве призов или выигрышей, сроках, месте и порядке их получения.',
    'istochnik-gde-mozhno-oznakomitsya-160':
        'источник, где можно ознакомиться с информацией об организаторе мероприятия, правилах проведения, количестве призов или выигрышей, сроках, месте и порядке их получения.',
    'istochnik-informacii-podlezhashchey-raskrytiyu':
        'Источник информации, подлежащей раскрытию в соответствии с законодательством Российской Федерации о ценных бумагах.',
    'istochnik-informacii-podlezhashchey-raskrytiyu-166':
        'источник информации, подлежащей раскрытию в соответствии с законодательством Российской Федерации о ценных бумагах;',
    'izmenite-kreativ': 'Измените креатив',
    'izobrazhenie-dolzhno-byt-kachestvennym':
        'Изображение должно быть качественным и чётким, без артефактов сжатия.',
    'izobrazhenie-dolzhno-davat-chyotkoe':
        'Изображение должно давать чёткое представление об источнике содержащейся в нем информации. Например, на изображении может присутствовать логотип, название бренда, название организации или ФИО индивидуального предпринимателя.',
    'izobrazhenie-graficheskogo-obyavleniya-dolzhno':
        'Изображение графического объявления должно быть качественным и чётким, без артефактов сжатия.',
    'izobrazhenie-ne-nbsp-dolzhno': 'Изображение не должно содержать:',
    'izobrazhenie-obyavleniya-dolzhno-davat':
        'Изображение объявления должно давать чёткое представление об источнике содержащейся в нем информации. Например, на изображении может присутствовать логотип, название бренда, название организации или ФИО индивидуального предпринимателя.',
    'izobrazhenie-obyavleniya-dolzhno-imet':
        'Изображение объявления должно иметь чёткие видимые границы и непрозрачный фон. Цвет рамки вокруг изображения не должен совпадать с цветом фона.',
    'izobrazheniya-kotorye-mogut-byt':
        'изображения, которые могут быть восприняты неоднозначно, шокировать или вызвать негативные эмоции;',
    'izobrazheniya-kotorye-ustoychivo-associiruyutsya':
        'изображения, которые устойчиво ассоциируются с лженовостями и другим "жёлтым" контентом. Например, фото до/после, «проблемные» обнажённые части тела, откровенные позы и т.д.;',
    'k-takoy-informacionnoy-produkcii':
        'К такой информационной продукции относятся:',
    'kachestvo-zagruzhennoy-kartinki-ochen':
        'Качество загруженной картинки очень низкое. Такое изображение будет неинформативным для пользователей.',
    'kak-naibolee-effektivno-podobrat':
        'Как наиболее эффективно подобрать ключевые фразы',
    'kak-zarabotat-v-nbsp':
        '«Как заработать в интернете? Курс на DVD» — понятно, что именно рекламируется.',
    'kak-zarabotat-v-nbsp-130':
        '«Как заработать в интернете? Спешите узнать» — объект рекламирования не ясен.',
    'kak-zarabotat-v-nbsp-134':
        '«Как заработать в интернете? Спешите узнать» — объект рекламирования не ясен.',
    'klyuchevye-frazy-dolzhny-imet':
        'Ключевые фразы должны иметь прямое отношение к теме рекламы.',
    'klyuchevye-frazy-dolzhny-imet-113':
        'Ключевые фразы должны иметь прямое отношение к теме объявления.',
    'klyuchevye-frazy-ne-nbsp':
        'Ключевые фразы не могут быть общими по значению («купить», «лето», «скидка»).',
    'komplekt-dokumentov-zavisit-ot':
        'Комплект документов зависит от тематики рекламы — найти перечни документов для самых распространённых тематик можно в {help}. ',
    'komplekt-dokumentov-zavisit-ot-param-help': 'помощи',
    'koncerty-vystavki-festivali-spektakli':
        'Концерты, выставки, фестивали, спектакли, шоу, спортивные матчи и другие зрелищные мероприятия (но не сами театры, концертные залы и другие места, если в их рекламе не упоминается конкретное мероприятие).',
    'koncerty-vystavki-festivali-spektakli-150':
        'концерты, выставки, фестивали, спектакли, шоу, спортивные матчи и другие зрелищные мероприятия (но не сами театры, концертные залы и другие места, если в их рекламе не упоминается конкретное мероприятие);',
    'konkretnye-programmy-i-peredachi':
        'Конкретные программы и передачи на ТВ и радио (но не сами телеканалы и радиостанции, если в их рекламе не упоминается конкретная передача).',
    'konkretnye-programmy-i-peredachi-152':
        'конкретные программы и передачи на ТВ и радио (но не сами телеканалы и радиостанции, если в их рекламе не упоминается конкретная передача).',
    'kontaktnuyu-informaciyu-naprimer-nomer':
        'контактную информацию (например, номер телефона, электронный адрес);',
    'kontaktnye-dannye': 'контактные данные.',
    'kreativ-dolzhen-imet-chyotkie':
        'Креатив должен иметь чёткие видимые границы и непрозрачный фон. Цвет рамки вокруг изображения не должен совпадать с цветом фона.',
    'kreativ-ne-dolzhen-soderzhat': 'Креатив не должен содержать:',
    'link-obekta-reklamirovaniya-net-param-link':
        'Объекта рекламирования нет в списке запрещённых',
    'mogut-byt-vosprinyaty-neodnoznachno':
        'могут быть восприняты неоднозначно, шокировать или вызывать негативные эмоции',
    'my-ne-nbsp-smogli':
        'Мы не смогли дозвониться по номеру из виртуальной визитки в обозначенное время работы.',
    'my-ne-nbsp-smogli-135':
        'Мы не смогли дозвониться до вас по номеру из виртуальной визитки.  Вероятно, контактный телефон указан с ошибкой.',
    'my-poluchili-oficialnuyu-zhalobu':
        'Мы получили официальную жалобу на нарушение прав интеллектуальной собственности от правообладателя. Дальнейшее размещение вашей рекламы с упоминанием данного объекта интеллектуальной собственности (товарного знака, фирменного наименования и т.п.) будет возможно только после того, как вы предоставите нам оригинал гарантийного письма от плательщика.',
    'my-takzhe-ne-nbsp':
        'Мы также не размещаем рекламу опросов общественного мнения относительно выборов и референдумов и рекламу прогнозов результатов выборов.',
    'na-sayte-otsutstvuyut-virusy': 'На сайте отсутствуют вирусы.',
    'na-stranice-perehoda-otsutstvuyut':
        'На странице перехода отсутствуют всплывающие окна (pop-up и pop-under).',
    'na-stranice-perehoda-prisutstvuet':
        'На странице перехода присутствует информация о скидке, акции или конкретном товаре (услуге), если она есть в тексте креатива.',
    'na-stranice-perehoda-prisutstvuet-104':
        'На странице перехода присутствует информация о скидке, акции или конкретном товаре (услуге), если она есть в тексте объявления.',
    'na-stranice-perehoda-prisutstvuet-143':
        'На странице перехода присутствует информация о скидке, акции или конкретном товаре (услуге), если эта информация есть в названии быстрой ссылки.',
    'na-stranice-perehoda-razmeshcheny':
        'На странице перехода размещены контактные данные рекламодателя.',
    'na-stranice-perehoda-ukazana':
        'На странице перехода указана информация о стоимости и форме оплаты предлагаемых услуг.',
    'naimenovanie-yuridicheskogo-lica-fio':
        'Наименование юридического лица/ФИО индивидуального предпринимателя.',
    'naimenovanie-yuridicheskogo-lica-fio-154':
        'наименование юридического лица/ФИО индивидуального предпринимателя;',
    'naimenovanie-yuridicheskogo-lica-ili':
        'Наименование юридического лица (или ФИО индивидуального предпринимателя).',
    'naimenovanie-yuridicheskogo-lica-ili-165':
        'наименование юридического лица (или ФИО индивидуального предпринимателя);',
    naprimer: 'Например',
    'narkoticheskie-psihotropnye-veshchestva-i':
        'наркотические, психотропные вещества и прекурсоры',
    'naturalisticheskie-izobrazheniya-bolezney-medicinskih':
        'натуралистические изображения болезней, медицинских процедур и операций, военных действий.',
    'ne-dopuskaetsya': 'Не допускается',
    'ne-ispolzuyte-v-audiorolike':
        'Не используйте в аудиоролике звуки, которые имитируют дорожное движение и могут навредить участникам дорожного движения (звуки сирен, клаксонов, визг тормозов и т.п.).',
    'nelzya-ispolzovat-izobrazheniya-kotorye':
        'Нельзя использовать изображения, которые',
    'nelzya-reklamirovat': 'Нельзя рекламировать:',
    'not-medicine-topic': 'Товары и услуги, не относящиеся к медицине',
    'obekt-reklamirovaniya-chyotko-opredelyon':
        'Объект рекламирования чётко определён.',
    'obekt-reklamirovaniya-chyotko-opredelyon-102':
        'Объект рекламирования чётко определён в тексте объявления.',
    'obrazy-kotorye-ne-sootvetstvuyut':
        'образы, которые не соответствуют заголовку, тексту объявления и содержанию страницы перехода;',
    'odnotonnuyu-zalivku-tekst-logotipy':
        'однотонную заливку, текст, логотипы или водяные знаки, которые занимают более 20% от всего изображения;',
    'opechatki-grammaticheskie-i-orfograficheskie':
        'опечатки, грамматические и орфографические ошибки;',
    'opisanie-bystroy-ssylki-dolzhno':
        'Описание быстрой ссылки должно соответствовать теме и тексту объявления, рекламируемому товару / услуге.',
    oruzhie: 'оружие',
    'oruzhie-142': 'оружие;',
    'oshibki-ustraneny-nuzhna-povtornaya':
        'Ошибки устранены, нужна повторная проверка баннера',
    'oshibki-ustraneny-nuzhna-povtornaya-100':
        'Ошибки устранены, нужна повторная проверка объявления',
    'ostalis-drugie-voprosy-po': 'Остались другие вопросы по сервису',
    'ostavit-zayavku-na-vozvrat': 'Оставить заявку на возврат средств',
    'otobrazhaemaya-ssylka-dolzhna-sootvetstvovat':
        'Отображаемая ссылка должна соответствовать тексту объявления.',
    'otpravit-dokumenty': 'Отправить документы',
    'pechatnye-i-internet-izdaniya':
        'Печатные и интернет-издания — газеты, журналы, книги.',
    'pechatnye-i-internet-izdaniya-151':
        'печатные и интернет-издания (газеты, журналы, книги);',
    'pered-zapolneniem-garantiynogo-pisma':
        'Перед заполнением гарантийного письма, пожалуйста, ознакомьтесь с {rules}.',
    'pered-zapolneniem-garantiynogo-pisma-param-rules':
        'правилами его оформления',
    'pisat-imena-sobstvennye-so':
        'писать имена собственные со строчной буквы (в том числе в ключевых фразах, если вы используете шаблон);',
    'pisat-imena-sobstvennye-so-145':
        'писать имена собственные со строчной буквы;',
    'pisat-slova-zaglavnymi-bukvami':
        'писать слова заглавными буквами (за исключением аббревиатур);',
    'pisat-video-imena-sobstvennye-so':
        'писать имена собственные со строчной буквы;',
    'podrobnoe-opisanie-obekta-reklamirovaniya':
        'Подробное описание объекта рекламирования (например, товара или услуги) в вашей виртуальной визитке требует предоставления документов.',
    'polnyy-spisok-trebovaniy': 'Полный список требований',
    'polnyy-spisok-trebovaniy-k': 'Полный список требований к изображениям',
    'pravila-pokaza': 'Правила показа',
    'pravila-razmeshcheniya-reklamy': 'Правила размещения рекламы',
    'predostavte-garantiynoe-pismo-ot':
        'Предоставьте гарантийное письмо от плательщика',
    'predostavte-original-garantiynogo-pisma':
        'Предоставьте оригинал гарантийного письма',
    'predostavte-podtverzhdayushchie-dokumenty-na':
        'Предоставьте подтверждающие документы на рекламируемый товар / услугу',
    'pri-proverke-odna-ili':
        'При проверке одна или все страницы сайта, на которые ведут быстрые ссылки, были недоступны.',
    'pri-reklame-rezultatov-intellektualnoy':
        'При рекламе результатов интеллектуальной деятельности (музыка, видеокурсы, книги, программные продукты и т.п.) предоставление гарантийного письма является обязательным.',
    'primer-7-916-123': 'Пример: +7 (916) 123-45-67.',
    'prodazhu-i-nbsp-poddelku': 'продажу и подделку официальных документов',
    'proverka-dokumentov-mozhet-zanimat':
        'Проверка документов может занимать некоторое время. Пожалуйста, не высылайте документы повторно — как только проверка будет закончена, вы получите уведомление на адрес электронной почты, который вы указали при отправке',
    'proverte-chto-audiorolik': 'Проверьте, что аудиоролик:',
    'proverte-chtoby-pri-podstanovke':
        'Проверьте, чтобы при подстановке ключевых слов в шаблон все слова в тексте были согласованы между собой.',
    'proverte-pravilno-nbsp-li':
        'Проверьте, правильно ли указаны рабочее время и номер телефона. При необходимости внесите изменения и отправьте объявление на повторную проверку.',
    'pyrotechnics-topic': 'Пиротехника',
    'realtors-topic': 'Риэлторы',
    'recepturnye-preparaty': 'рецептурные препараты',
    'reklama-bad-dolzhna-soderzhat':
        'Реклама БАД должна содержать предупреждение о том, что товар не является лекарством. Информация должна занимать не менее 10% площади креатива.',
    'reklama-bankovskih-strahovyh-i':
        'Реклама банковских, страховых и иных финансовых услуг должна содержать наименование юридического лица (или ФИО индивидуального предпринимателя).',
    'reklama-cennyh-bumag-dolzhna':
        'Реклама ценных бумаг должна содержать наименование лиц, обязавшихся по ценным бумагам и  источник информации, подлежащей раскрытию в соответствии с законодательством Российской Федерации о ценных бумагах.',
    'reklama-cennyh-bumag-dolzhna-163':
        'реклама ценных бумаг должна содержать наименование лиц, обязавшихся по ценным бумагам и источник информации, подлежащей раскрытию в соответствии с законодательством Российской Федерации о ценных бумагах;',
    'reklama-distancionnoy-prodazhi-tovarov':
        'Реклама дистанционной продажи товаров должна содержать наименование юридического лица/ФИО индивидуального предпринимателя, его адрес и ОГРН.',
    'reklama-dolevogo-stroitelstva-dolzhna':
        'Реклама долевого строительства должна содержать наименование юридического лица (или ФИО индивидуального предпринимателя), а также сведения о месте и способах получения проектной декларации. Данная информация должна быть визуально выделена (например, размером, шрифтом или подчёркиванием) и свободно восприниматься потребителем одновременно с рекламой без совершения дополнительных действий.',
    'reklama-emissionnyh-cennyh-bumag':
        'Реклама эмиссионных ценных бумаг должна содержать наименование эмитента и  источник информации, подлежащей раскрытию в соответствии с законодательством Российской Федерации о ценных бумагах.',
    'reklama-emissionnyh-cennyh-bumag-164':
        'реклама эмиссионных ценных бумаг должна содержать наименование эмитента и источник информации, подлежащей раскрытию в соответствии с законодательством Российской Федерации о ценных бумагах.',
    'reklama-lekarstvennyh-sredstv-medicinskoy':
        'Реклама лекарственных средств, медицинской техники, медицинских услуг и методов лечения должна содержать предупреждение о наличии противопоказаний, необходимости ознакомления с инструкцией по применению или получения консультации специалиста. Предупреждение должно занимать не менее 5% площади креатива.',
    'reklama-po-upravleniyu-akciyami':
        'Реклама по управлению акциями, фондами, накоплениями и т.п. должна содержать:',
    'reklama-produktov-vklyuchyonnyh-v':
        'Реклама продуктов, включённых в рацион ребёнка в течение его первого года жизни, или заменителей женского молока должна содержать возрастное ограничение применения и предупреждение о необходимости консультации специалиста.',
    'reklama-provedeniya-stimuliruyushchego-meropriyatiya':
        'Реклама проведения стимулирующего мероприятия (например, лотереи или конкурса) должна содержать:',
    'reklama-zhilishchno-nakopitelnyh-kooperativov':
        'Реклама жилищно-накопительных кооперативов (ЖНК) должна содержать:',
    'reklamnye-bloki-na-nbsp':
        'Рекламные блоки на странице перехода занимают менее половины экрана.',
    's-pomoshchyu-garantiynogo-pisma':
        'С помощью гарантийного письма вы подтверждаете, что соблюдаете права третьих лиц в отношении интеллектуальной собственности. При этом вы не обязаны быть автором или правообладателем объекта рекламирования.',
    'sayt-predstavlen-na-nbsp':
        'Сайт представлен на языке рекламного объявления или в тексте объявления указан язык сайта.',
    'sayt-sostavlen-na-nbsp':
        'Сайт составлен на языке креатива, или в тексте креатива указан язык сайта.',
    'sayt-sostavlen-na-nbsp-105':
        'Сайт составлен на языке рекламного объявления, или в тексте объявления указан язык сайта.',
    'sinhronnyy-s-videorolikom': 'синхронный с видеороликом.',
    'slishkom-otkrovennye-illyustracii-odezhdy':
        'слишком откровенные иллюстрации одежды и нижнего белья, фитнеса, салонов красоты, туристических и других услуг;',
    'slova-nabrannye-translitom-ili':
        'слова, набранные транслитом или заглавными буквами;',
    'slova-v-nbsp-prevoshodnoy':
        'Слова в превосходной или сравнительной степени можно использовать в тексте креатива, если на странице перехода размещено заключение третьих лиц о преимуществе вашего товара (услуги) перед другими товарами.',
    'slova-v-nbsp-prevoshodnoy-109':
        'Слова в превосходной или сравнительной степени можно использовать в тексте объявления, если на странице перехода размещено заключение третьих лиц о преимуществе вашего товара (услуги) перед другими товарами.',
    'slova-v-sravnitelnoy-ili':
        'слова в сравнительной или превосходной степени;',
    'soderzhat-naturalisticheskie-izobrazheniya-bolezney':
        'содержат натуралистические изображения болезней, медицинских процедур и операций',
    'sootvetstvuet-zagolovku-tekstu-obyavleniya':
        'соответствует заголовку, тексту объявления и содержанию страницы перехода;',
    'special-categories-link-turbo': 'запрещенные товары или услуги',
    'sroki-provedeniya-meropriyatiya': 'Сроки проведения мероприятия.',
    'sroki-provedeniya-meropriyatiya-159': 'сроки проведения мероприятия;',
    'stranica-perehoda-dolzhna-sootvetstvovat':
        'Страница перехода должна соответствовать креативу (например, если в тексте креатива есть информация о конкретном товаре, акции, скидке и т.п., то эта же информация должна присутствовать на странице перехода).',
    'stranica-perehoda-dolzhna-sootvetstvovat-103':
        'Страница перехода должна соответствовать тексту объявления (например, если в объявлении есть информация о конкретном товаре, акции, скидке и т.п., то эта же информация должна присутствовать на странице перехода).',
    'stranica-perehoda-otkryvaetsya-korrektno':
        'Страница перехода открывается корректно во всех браузерах.',
    'svedeniya-o-nomere-telefona':
        'Сведения о номере телефона, месте или адресе, где до заключения договора можно ознакомиться с условиями управления активами и получить иную информацию, предусмотренную законодательством.',
    'svedeniya-o-nomere-telefona-167':
        'сведения о номере телефона, месте или адресе, где до заключения договора можно ознакомиться с условиями управления активами и получить иную информацию, предусмотренную законодательством.',
    'svedeniya-o-vklyuchenii-zhnk': 'Сведения о включении ЖНК в реестр ЖНК.',
    'svedeniya-o-vklyuchenii-zhnk-156':
        'сведения о включении ЖНК в реестр ЖНК;',
    'tabachnuyu-produkciyu-i-nbsp':
        'табачную продукцию и курительные принадлежности',
    'tabachnuyu-produkciyu-i-nbsp-141':
        'табачную продукцию и курительные принадлежности;',
    'tabak-i-nbsp-tabachnye': 'табак и табачные изделия',
    'tekst-dolzhen-svobodno-vosprinimatsya':
        'Текст должен свободно восприниматься пользователем без дополнительных действий или специальных средств.',
    'telefon-dolzhen-byt-propisan':
        'Телефон должен быть прописан в формате: (код страны) (код города или мобильного оператора) (номер телефона).',
    'turbolanding-requirements-1':
        'Убедитесь, что Турбо-страница соответствует требованиям Яндекса:',
    'turbolanding-requirements-2':
        'содержание страницы соответствует рекламному тексту (например, если в объявлении есть информация о конкретном товаре, акции, скидке и т.п., то эта же информация должна присутствовать на странице перехода);',
    'turbolanding-requirements-3': 'не предлагаются {special-categories-link};',
    'turbolanding-requirements-4':
        'рекламные блоки занимают менее половины экрана;',
    'turbolanding-requirements-5':
        'страница составлена на языке рекламного объявления или в объявлении указан язык сайта.',
    'turbolanding-requirements-slink-1':
        'Убедитесь, что Турбо-страница соответствует требованиям Яндекса:',
    'turbolanding-requirements-slink-2':
        'содержание страниц соответствует рекламному тексту (например, если в быстрой ссылке есть информация о конкретном товаре, акции, скидке и т.п., то эта же информация должна присутствовать на странице перехода);',
    'turbolanding-requirements-slink-3':
        'не предлагаются {special-categories-link};',
    'turbolanding-requirements-slink-4':
        'рекламные блоки занимают менее половины экрана;',
    'turbolanding-requirements-slink-5':
        'страницы составлены на языке рекламного объявления или в названии быстрых ссылок указан язык сайта;',
    'ubedites-chto-audiorolik-sootvetstvuet':
        'Убедитесь, что аудиоролик соответствует требованиям',
    'ubedites-chto-bystrye-ssylki':
        'Убедитесь, что быстрые ссылки ведут на тот же сайт или раздел сайта, что и основная ссылка из рекламного объявления.',
    'ubedites-chto-graficheskoe-obyavlenie-119':
        'Убедитесь, что графическое объявление содержит необходимую информацию о мероприятии',
    'ubedites-chto-izobrazhenie-sootvetstvuet':
        'Убедитесь, что изображение соответствует тематике баннера',
    'ubedites-chto-kreativ-imeet':
        'Убедитесь, что креатив имеет видимые границы',
    'ubedites-chto-kreativ-ne':
        'Убедитесь, что креатив не содержит элементы пользовательского графического интерфейса',
    'ubedites-chto-kreativ-soderzhit':
        'Убедитесь, что креатив содержит достаточную информацию о предоставителе услуг и источник информации',
    'ubedites-chto-kreativ-soderzhit-118':
        'Убедитесь, что креатив содержит необходимую информацию о мероприятии',
    'ubedites-chto-kreativ-soderzhit-120':
        'Убедитесь, что креатив содержит данные о продавце',
    'ubedites-chto-kreativ-soderzhit-123':
        'Убедитесь, что креатив содержит категорию информационной продукции',
    'ubedites-chto-kreativ-soderzhit-126':
        'Убедитесь, что креатив содержит информацию о жилищно-накопительном кооперативе',
    'ubedites-chto-kreativ-sootvetstvuet':
        'Убедитесь, что креатив соответствует требованиям к рекламе детского питания',
    'ubedites-chto-reklama-soprovozhdaetsya':
        'Убедитесь, что реклама сопровождается необходимым предупреждением',
    'ubedites-chto-sayt-ispolzuemyy':
        'Убедитесь, что сайт, используемый в рекламе, работает, а страница, перехода открывается корректно.',
    'ubedites-chto-sayt-ispolzuemyy-112':
        'Убедитесь, что сайт, используемый в объявлении, работает, а страница, на которую ссылается объявление, открывается корректно.',
    'ubedites-chto-ssylka-s':
        'Убедитесь, что ссылка с объявления ведет на соответствующее приложение в магазине.',
    'ubedites-chto-tekst-kreativa':
        'Убедитесь, что текст креатива можно прочитать',
    'ubedites-chto-v-kreative':
        'Убедитесь, что в креативе указан источник информации',
    'ubedites-chto-v-nbsp':
        'Убедитесь, что в тексте креатива есть указание на информационный ресурс',
    'ubedites-chto-v-nbsp-106':
        'Убедитесь, что в тексте объявления есть указание на информационный ресурс',
    'ubedites-chto-v-nbsp-110': 'Убедитесь, что в тексте креатива нет опечаток',
    'ubedites-chto-v-nbsp-111':
        'Убедитесь, что в тексте нет ошибок, а шаблон используется корректно',
    'ubedites-chto-v-nbsp-112': 'Убедитесь, что в тексте нет опечаток',
    'upravlenie-akciyami': 'Управление акциями',
    'utochnenie-ne-sootvetstvuet-reklamnoy':
        'Уточнение не соответствует рекламной политике Яндекса. Требования к рекламным материалам вы можете прочитать {link}.',
    'utochnenie-ne-sootvetstvuet-reklamnoy-param-link': 'здесь',
    'v-animacii-izobrazheniya-nelzya':
        'В анимации изображения нельзя использовать резко перемещающиеся и мелькающие графические элементы, мигающий фон.',
    'v-hode-proverki-byli':
        'В ходе проверки были выявлены несоответствия рекламной политике Яндекса. Более подробные комментарии не могут быть предоставлены. В соответствии с пунктом 15 {rules} Яндекс оставляет за собой право отклонить любой рекламный материал без объяснения причин.  Если на счёте вашей рекламной кампании остались средства, они могут быть возвращены — для этого необходимо предоставить оригинал заявления от плательщика.',
    'v-hode-proverki-byli-param-rules': 'Требований к рекламным материалам',
    'v-obyavlenii-ne-nbsp':
        'В объявлении не должны быть указаны номера телефонов, электронные или почтовые адреса. Вы можете указать эти данные в {vcard}.',
    'v-obyavlenii-ne-nbsp-param-vcard': 'виртуальной визитке',
    'v-obyavleniyah-s-targetingom':
        'В объявлениях с таргетингом на Россию, которые содержат рекламу, попадающую под действие закона ФЗ от 29 декабря 2010 года N 436-ФЗ "О защите детей от информации, причиняющей вред их здоровью и развитию", необходимо указывать возрастную категорию.',
    'v-sootvetstvii-s-chastyu':
        'В соответствии с частью 10.1 статьи 5 Федерального закона «О рекламе» не допускается размещение рекламы информационной продукции без указания её возрастной категории.',
    'v-tekste-kreativa-est':
        'В тексте креатива есть предупреждение о том, что необходимо зарегистрироваться на сайте (если регистрация обязательна).',
    'v-tekste-ne-dopuskaetsya': 'В тексте не допускается',
    'v-tekste-obyavleniya-chyotko':
        'В тексте объявления чётко описан объект рекламирования.',
    'v-tekste-obyavleniya-est':
        'В тексте объявления есть предупреждение о том, что необходимо зарегистрироваться на сайте (если регистрация обязательна).',
    'v-tekste-obyavleniya-ne': 'В тексте объявления не допускается',
    'v-tekste-otobrazhaemoy-ssylki':
        'В тексте отображаемой ссылки не допускаются',
    'v-tekste-utochneniya-est':
        'В тексте уточнения есть ошибки. Подробнее о причине отклонения вы можете прочитать {link}.',
    'v-tekste-utochneniya-est-147':
        'В тексте уточнения есть слова в превосходной или сравнительной степени. Подробнее о причине отклонения вы можете прочитать {link}.',
    'v-tekste-utochneniya-est-147-param-link': 'здесь',
    'v-tekste-utochneniya-est-param-link': 'здесь',
    'v-tekste-utochneniya-ukazany':
        'В тексте уточнения указаны контактные данные. Подробнее о причине отклонения вы можете прочитать {link}.',
    'v-tekste-utochneniya-ukazany-param-link': 'здесь',
    'v-tekste-video-obyavleniya-ne': 'В рекламном тексте не допускается',
    'vash-kreativ-ne-mozhet':
        'Ваш креатив не может быть принят к размещению, поскольку рекламные материалы содержат информацию о запрещённых к рекламе товарах/услугах. ',
    'vashe-reklamnoe-obyavlenie-ne':
        'Ваше рекламное объявление не может быть принято к размещению, поскольку рекламные материалы содержат информацию о запрещённых к рекламе товарах/услугах. ',
    'videorolik-dolzhen-byt-kachestvennym':
        'Видеоролик должен быть качественным и чётким, без артефактов сжатия. В анимации видеоролика нельзя использовать резко перемещающиеся и мелькающие графические элементы, мигающий фон, изображения с гипнотическим эффектом.',
    'videorolik-ne-dolzhen-soderzhat': 'Видеоролик не должен содержать:',
    'videorolik-o-lekarstvennyh-sredstvah':
        'Видеоролик о лекарственных средствах, медицинской технике, медицинских услугах и методах лечения должен содержать предупреждение о наличии противопоказаний, необходимости ознакомления с инструкцией по применению или получения консультации специалиста. Предупреждение должно показываться на протяжении всего времени и занимать не менее 5% площади видеоролика.',
    'videorolik-s-reklamoy-bad':
        'Видеоролик с рекламой БАД должен содержать предупреждение о том, что товар не является лекарством. Предупреждение должно показываться на протяжении всего времени и занимать не менее 10% площади видеоролика.',
    'videorolik-s-reklamoy-distancionnoy':
        'Видеоролик с рекламой дистанционной продажи товаров должен содержать наименование юридического лица/ФИО индивидуального предпринимателя, его адрес и ОГРН. Время показа данной информации должно быть достаточным для прочтения всего текста при средней скорости чтения 150 знаков в минуту.',
    'videorolik-s-reklamoy-produktov':
        'Видеоролик с рекламой продуктов, включенных в рацион ребенка в течение его первого года жизни, или заменителей женского молока должен содержать возрастное ограничение применения и предупреждение о необходимости консультации специалиста. Эта информация должна показываться на протяжении всего времени.',
    'videorolik-s-reklamoy-stimuliruyushchego':
        'Видеоролик с рекламой  стимулирующего мероприятия (например, лотереи или конкурса) должен содержать:  ',
    'videorolik-s-reklamoy-zhilishchno':
        'Видеоролик с рекламой жилищно-накопительного кооператива (ЖНК) должен содержать:',
    'vnesite-neobhodimye-izmeneniya-i':
        'Внесите необходимые изменения и отправьте объявление на повторную проверку.',
    'vremya-pereklyucheniya-kadrov-na':
        'Время переключения кадров на анимированном изображении должно быть достаточным для прочтения всего показанного текста при средней скорости чтения 150 знаков в минуту.',
    'vremya-pokaza-dannoy-informacii':
        'Время показа данной информации должно быть достаточным для прочтения всего текста при средней скорости чтения 150 знаков в минуту.',
    'vremya-pokaza-vozrastnoy-kategorii':
        'Время показа возрастной категории должно быть достаточным для прочтения всего текста при средней скорости чтения 150 знаков в минуту.',
    'vy-mozhete-ispolzovat-slova':
        'Вы можете использовать слова в превосходной или сравнительной степени, только если на странице перехода размещено заключение третьих лиц о преимуществе вашего товара или услуги перед другими товарами.',
    'vy-mozhete-ispolzovat-utochnyayushchie':
        'Вы можете использовать уточняющие фразы: «подробнее на», «читайте на», «обзор» и т.п.',
    'weapons-topic': 'Товары, конструктивно сходные с оружием',
    'yandex-policy-title':
        'Объект рекламирования чётко определён в тексте объявления. Например:',
    'yazyk-sayta-i-nbsp':
        'Язык сайта и текста креатива, а также стоимостные показатели (валюта) должны соответствовать стране размещения рекламы.',
    'yazyk-sayta-i-nbsp-101':
        'Язык сайта и объявления, а также стоимостные показатели (валюта) должны соответствовать стране размещения рекламы.',
    'zhargonnye-grubye-prostorechnye-vyrazheniya':
        'жаргонные, грубые, просторечные выражения;'
};
